import { Checkbox, IconButton, TableCell, TableRow, useTheme } from '@mui/material'

import { useMe, useTableItemsCheck } from 'src/hooks'

import { IDeclineReasonsBaseWithId } from 'src/types'
import { getTableTimestamp } from 'src/common/utils'
import EditIcon from '@mui/icons-material/Edit'
import { useState } from 'react'
import { UpdateDeclineReason } from '../forms/update/form-wrapper.component'

interface IProps
  extends Pick<ReturnType<typeof useTableItemsCheck>, 'isItemSelected' | 'handleItemCheck'> {
  row: IDeclineReasonsBaseWithId
}

export const TableItem = ({ row, isItemSelected, handleItemCheck }: IProps) => {
  const { data: user } = useMe()

  const [open, setOpen] = useState(false)

  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)

  const theme = useTheme()

  return (
    <>
      <TableRow>
        <TableCell align="center">
          <Checkbox
            checked={isItemSelected(row.id)}
            onChange={handleItemCheck(row.id)}
            sx={{ color: theme.palette.custom.grey2 }}
          />
        </TableCell>
        <TableCell>{row.name}</TableCell>
        <TableCell>{row.reason_text}</TableCell>

        <TableCell align="center" sx={{ fontSize: '11px' }}>
          {getTableTimestamp({ date: row.created_at, timezone: user?.timezone })}
        </TableCell>
        <TableCell width="24%" align="center">
          <IconButton onClick={handleOpen}>
            <EditIcon />
          </IconButton>
        </TableCell>
      </TableRow>
      <UpdateDeclineReason
        handleClose={handleClose}
        open={open}
        id={row.id}
        initial={{
          name: row.name,
          reason_text: row.reason_text,
        }}
      />
    </>
  )
}
